import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import RichTextEditor from '../../components/RichTextEditor';
import './AjouterVente.css';

import api from '../../api';

function AjouterVente() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: '',
    localisation: {
      city: '',
      district: '',
      name: '',
      country: ''
    },
    description: '',
    category: '',
    status: 'Disponible',
    details: {
      reference: '',
      area: '',
      price: ''
    },
    autres: [],
    images: []
  });

  const [files, setFiles] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes('localisation.')) {
      const field = name.split('.')[1];
      setFormData((prev) => ({
        ...prev,
        localisation: { ...prev.localisation, [field]: value }
      }));
    } else if (name.includes('details.')) {
      const field = name.split('.')[1];
      setFormData((prev) => ({
        ...prev,
        details: { ...prev.details, [field]: value }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleAutresChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      autres: e.target.value.split(',').map((item) => item.trim())
    }));
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  /*const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Convertir les fichiers en base64
    const base64Images = await Promise.all(
      files.map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result.split(',')[1]); // on ne garde que la partie base64
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      })
    );
  
    try {
      const payload = {
        ...formData,
        details: formData.details,
        localisation: formData.localisation,
        autres: formData.autres,
        images: base64Images
      };
  
      //const res = await axios.post('http://localhost:5000/api/sales', payload, {
      const res = await api.post('/sales', payload, {
        headers: { 'Content-Type': 'application/json' }
      });
  
      alert('Vente ajoutée avec succès');
      console.log(res.data);
      navigate('/ventes');
    } catch (error) {
      console.error('Erreur:', error);
      alert("Erreur lors de l'ajout de la vente");
    }
  };*/
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('title', formData.title);
    data.append('description', formData.description);
    data.append('category', formData.category);
    data.append('status', formData.status);
    data.append('localisation', JSON.stringify(formData.localisation));
    data.append('details', JSON.stringify(formData.details));
    data.append('autres', JSON.stringify(formData.autres));

    files.forEach((file) => {
      data.append('images', file);
    });

    try {
      const res = await api.post('/sales', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert('Vente ajoutée avec succès');
      console.log(res.data);
      navigate('/ventes');
    } catch (error) {
      console.error('Erreur:', error);
      alert("Erreur lors de l'ajout de la vente");
    }
  };

  

  return (
    <div className="ajouter-vente-container">
      <h2>Ajouter une Vente</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input type="text" name="title" placeholder="Titre" onChange={handleChange} required />
        <input type="text" name="localisation.city" placeholder="Ville" onChange={handleChange} required />
        <input type="text" name="localisation.district" placeholder="Quartier" onChange={handleChange} required />
        <input type="text" name="localisation.name" placeholder="Nom de la propriété" onChange={handleChange} required />
        <input type="text" name="localisation.country" placeholder="Pays" onChange={handleChange} required />

        <RichTextEditor
          value={formData.description}
          onChange={(value) => setFormData((prev) => ({ ...prev, description: value }))}
          placeholder="Description de la vente"
        />

        <select name="category" onChange={handleChange} required>
          <option value="">Catégorie</option>
          <option value="Terrains">Terrains</option>
          <option value="Appartements">Appartements</option>
          <option value="Maisons">Maisons</option>
          <option value="Champs">Champs</option>
        </select>

        <input type="text" name="details.area" placeholder="Superficie (ex: 450m²)" onChange={handleChange} />
        <input type="number" name="details.price" placeholder="Prix" onChange={handleChange} required />

        <input type="text" name="autres" placeholder="Commodités (séparées par virgule)" onChange={handleAutresChange} />

        <input type="file" name="images" multiple accept="image/*" onChange={handleFileChange} required />

        <button type="submit">Ajouter la vente</button>
      </form>
    </div>
  );
}

export default AjouterVente;
